module.exports = __webpack_public_path__ + "img/pdf.fb6a99f5.png";